import { render } from "./assessment-mobile.vue?vue&type=template&id=2b267a5b&scoped=true&ts=true"
import script from "./assessment-mobile.vue?vue&type=script&lang=ts"
export * from "./assessment-mobile.vue?vue&type=script&lang=ts"

import "./assessment-mobile.vue?vue&type=style&index=0&id=2b267a5b&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b267a5b"]])

export default __exports__